import { motion } from "framer-motion";

export default function SectionHeading({ eyebrow, title, sub, align = "left", testId }) {
  return (
    <div
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} space-y-4`}
      data-testid={testId}
    >
      {eyebrow && (
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="font-inter text-xs tracking-[0.24em] uppercase text-[#10B981] font-semibold"
        >
          {eyebrow}
        </motion.p>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.05 }}
        className="font-poppins text-3xl sm:text-4xl md:text-5xl tracking-tight text-white font-semibold leading-[1.1]"
      >
        {title}
      </motion.h2>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="font-inter text-base md:text-lg text-white/60 leading-relaxed"
        >
          {sub}
        </motion.p>
      )}
    </div>
  );
}
